import { normalizeAreaId } from './normalize.js';
import { columnIndex } from './types.js';
import { validateAreaLevelTable } from './validate.js';
export function tableToAreaLevelCell(table, roles, options = {}) {
    const issues = validateAreaLevelTable(table, roles, options);
    if (issues.some((i) => i.severity === 'error')) {
        return { cell: null, issues };
    }
    const percent = (options.estimateScale ?? 'proportion') === 'percent';
    const iArea = columnIndex(table, roles.area);
    const iEst = columnIndex(table, roles.estimate);
    const iVar = roles.variance ? columnIndex(table, roles.variance) : -1;
    const iSe = roles.standardError ? columnIndex(table, roles.standardError) : -1;
    const iN = columnIndex(table, roles.sampleSize);
    const iPop = roles.populationCount
        ? columnIndex(table, roles.populationCount)
        : -1;
    const covNames = roles.covariates ?? [];
    const iCovs = covNames.map((n) => columnIndex(table, n));
    const domains = [];
    const covariates = [];
    for (const row of table.rows) {
        const areaCell = row[iArea];
        if (areaCell === null || areaCell === '')
            continue; // error already
        const areaId = normalizeAreaId(areaCell);
        const est = row[iEst];
        let variance = null;
        if (iVar >= 0 && typeof row[iVar] === 'number') {
            variance = percent ? row[iVar] / 10000 : row[iVar];
        }
        else if (iSe >= 0 && typeof row[iSe] === 'number') {
            const se = percent ? row[iSe] / 100 : row[iSe];
            variance = se * se;
        }
        const n = row[iN];
        if (typeof est === 'number' && variance !== null && typeof n === 'number') {
            domains.push({
                areaId,
                directEstimate: percent ? est / 100 : est,
                samplingVariance: variance,
                sampleSize: n,
            });
        }
        if (covNames.length > 0 || iPop >= 0) {
            const values = {};
            let complete = true;
            covNames.forEach((name, k) => {
                const v = row[iCovs[k]];
                if (typeof v === 'number')
                    values[name] = v;
                else
                    complete = false;
            });
            if (complete) {
                const pop = iPop >= 0 ? row[iPop] : null;
                covariates.push({
                    areaId,
                    values,
                    ...(typeof pop === 'number' && pop > 0
                        ? { populationCount: pop }
                        : {}),
                });
            }
        }
    }
    return {
        cell: {
            indicatorId: roles.indicatorId ?? 'indicator',
            domains,
            covariates,
        },
        issues,
    };
}
//# sourceMappingURL=area-level.js.map